import React, { useState, useEffect, useRef } from 'react';
import '../../styles/components/common/Navigation.css';

const Navigation = ({ activeSection, menuOpen, setMenuOpen, scrollToSection }) => {
  const [scrolled, setScrolled] = useState(false);
  const [visible, setVisible] = useState(true);
  const timeoutRef = useRef(null);

  useEffect(() => {
    const handleScroll = () => {
      // 1. Provera da li je stranica skrolovana (za promenu boje)
      setScrolled(window.scrollY > 30);

      // 2. Pri svakom skrolu prikaži meni
      setVisible(true);

      // 3. Resetuj tajmer
      if (timeoutRef.current) {
        clearTimeout(timeoutRef.current);
      }

      // 4. Ako nismo na samom vrhu, postavi tajmer da sakrije meni nakon 2.5s neaktivnosti
      // Ako je meni otvoren (mobilni), ne sakrivaj ga
      if (window.scrollY > 100 && !menuOpen) {
        timeoutRef.current = setTimeout(() => {
          setVisible(false);
        }, 2500);
      }
    };

    window.addEventListener('scroll', handleScroll);
    return () => {
      window.removeEventListener('scroll', handleScroll);
      if (timeoutRef.current) clearTimeout(timeoutRef.current);
    };
  }, [menuOpen]); // Reaguj na promenu menuOpen

  const navItems = [
    { id: 'instructions', label: 'KORACI' },
    { id: 'about', label: 'O NAMA' },
    { id: 'memberships', label: 'PAKETI' },
    { id: 'locations', label: 'PERIONICE' },
  ];

  return (
    <nav className={`navbar 
      ${scrolled ? 'scrolled' : ''} 
      ${!visible ? 'nav-hidden' : ''} 
      ${menuOpen ? 'menu-is-open' : ''}`
    }>
      <div className="nav-container">
        
        <div className="nav-logo" onClick={() => scrollToSection('home')}>
          <img src="/images/logo_removed.png" alt="CLICKWASH" className="logo-image" />
        </div>

        <div className="nav-content">
          <ul className={`nav-menu ${menuOpen ? 'active' : ''}`}>
            {navItems.map(item => (
              <li key={item.id}>
                <a 
                  href={`#${item.id}`}
                  className={activeSection === item.id ? 'active' : ''}
                  onClick={(e) => {
                    e.preventDefault();
                    scrollToSection(item.id);
                  }}
                >
                  {item.label}
                </a>
              </li>
            ))}
          </ul>
        </div>

        <div 
          className={`hamburger ${menuOpen ? 'active' : ''}`} 
          onClick={() => setMenuOpen(!menuOpen)}
        >
          <span></span>
          <span></span>
          <span></span>
        </div>
      </div>
    </nav>
  );
};

export default Navigation;